import Vue from "vue";
import "./plugins/vuetify";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import firebase from "firebase/app";
import "firebase/auth";
import axios from "axios";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faUserCheck,
  faUserSlash,
  faCloudDownload,
  faCalendarExclamation,
  faCalendarTimes,
  faLockAlt,
  faExchange,
  faSignOut,
  faSignIn,
  faUndoAlt,
  faTicket,
  faUsers,
  faUserPlus,
  faCheckCircle,
  faExclamationTriangle,
  faPaperPlane,
  faClipboardListCheck,
  faFileDownload,
  faUserCircle,
  faTimesCircle,
  faFileSignature,
  faFileImport,
  faQuestionCircle,
  faPlus,
  faSync
} from "@fortawesome/pro-light-svg-icons";

import {
  faInfoCircle,
  faCloudDownloadAlt,
  faExclamationCircle
} from "@fortawesome/pro-solid-svg-icons";

import {
  faChrome,
  faFirefox,
  faEdge,
  faSafari
} from "@fortawesome/free-brands-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faUserCheck,
  faUserSlash,
  faCloudDownload,
  faCalendarExclamation,
  faCalendarTimes,
  faLockAlt,
  faExchange,
  faSignOut,
  faSignIn,
  faUndoAlt,
  faTicket,
  faUsers,
  faUserPlus,
  faExclamationCircle,
  faChrome,
  faFirefox,
  faEdge,
  faSafari,
  faCheckCircle,
  faExclamationTriangle,
  faInfoCircle,
  faCloudDownloadAlt,
  faPaperPlane,
  faClipboardListCheck,
  faFileDownload,
  faUserCircle,
  faTimesCircle,
  faFileSignature,
  faFileImport,
  faQuestionCircle,
  faPlus,
  faSync
);

Vue.component("font-awesome-icon", FontAwesomeIcon);

Vue.config.productionTip = false;

firebase.initializeApp({
  apiKey: process.env.VUE_APP_API_KEY,
  authDomain: process.env.VUE_APP_AUTH_DOMAIN,
  databaseURL: process.env.VUE_APP_DATABASE_URL,
  projectId: process.env.VUE_APP_PROJECT_ID,
  storageBucket: process.env.VUE_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.VUE_APP_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FB_ID
});

firebase
  .auth()
  .setPersistence(firebase.auth.Auth.Persistence.SESSION)
  .then(function() {
    console.log("PERSISTENCE");
  })
  .catch(function(error) {
    console.log("ERROR SP", error.code, error.message);
  });

firebase.auth().onAuthStateChanged(user => {
  // console.log("ON AUHT STATE CHANGED", user);
  store.commit("SET_LOADING", true);
  if (user) {
    const userData = {
      email: user.email,
      uid: user.uid
    };
    firebase
      .database()
      .ref("admins")
      .once("value")
      .then(snapshot => {
        const admins = snapshot.val();
        const adminsArray = [];
        for (const key in admins) {
          adminsArray.push(admins[key].user);
        }
        const matchAdmin = adminsArray.findIndex(
          adminUser => adminUser === userData.email
        );
        if (matchAdmin !== -1) store.dispatch("adminData", userData);
        else store.dispatch("userData", userData);

        store.dispatch("changeAuth", true);
        store.dispatch("changeLoginState", true);

        if (router.history.current.path === "/login") {
          store.commit("SET_GENERAL_MESSAGE_SHOW_SB", false);
          router.push("/");
        } else {
          store.commit("SET_GENERAL_MESSAGE_SHOW_SB", false);
          router.push(router.history.current.path);
        }
        const projectId = process.env.VUE_APP_PROJECT_ID;
        return axios.get(
          `https://us-central1-${projectId}.cloudfunctions.net/getCurrentDate`
        );
      })
      .then(response => {
        // console.log("GET CURRENT DATE", response);
        store.dispatch("setCurrentDate", response.data);
      })
      .catch(error => {
        console.log("ERROR ADMINS DATA", error);
      });
  } else {
    // console.log("USER SIGNOUT -> ", user);
    store.commit("SET_LOADING", false);
    store.dispatch("changeAuth", false);
    store.dispatch("changeLoginState", false);
    router.push("/login");
  }
});

// firebase.auth().onIdTokenChanged(user => {
//   console.log("ON ID TOKEN CHANGED", user);
// });

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
